import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames';
import { Icon, Switch, AssistiveTextBuilder } from 'components';
import DotsMenu from '../components/DotsMenu/DotsMenu';
import styles from './CardBuilder.scss';

const CardBuilder = ({dragHandleProps, commonProps, children}) => {
  const {
    questionData,
    onToggleIsRequired,
    actions,
    isPreview,
    requiredLabel,
    handleClick,
    shouldDisplayLabel,
    shouldDisplayRequiredToggle,
    shouldDisplayeAssistiveText,
    assistiveTextLabels,
    onChangeAssistiveText
  } = commonProps;

  const [isRequired, setIsRequired] = useState(get(questionData, 'data.isRequired', true));
  
  const toggleIsRequired = event => {
    setIsRequired(event.target.checked);
    onToggleIsRequired(event, questionData);
  };

  return(
    <div
      className={classnames(
        styles.container,
        {
            [styles.cardActive]: !isPreview,
            [styles.noRequiredToggle] : !shouldDisplayRequiredToggle
        }
      )}
      onClick={() => handleClick(questionData.id)}
      data-testid={`question-${questionData.id}__builder`}
    >
      <div
        className={styles.handle}
        {...dragHandleProps}
      >
        <Icon name='ion-md-menu' size='small'/>
      </div>
      <div className={styles.cardContent}>
        {
          shouldDisplayeAssistiveText &&
            <div className={styles.assistiveText}>
                <AssistiveTextBuilder assistiveText
                    assistiveTextContent={{...questionData.data.assistiveText}}
                    assistiveTextLabels={assistiveTextLabels}
                    onUpdateText={(text) => onChangeAssistiveText(text)}
                    className={styles.assistiveTextIcon}
                />
            </div>
        }
        <div className={styles.menuHolder}>
          <DotsMenu
            actions={actions}
            questionId={questionData.id}
          />
        </div>
        {
          shouldDisplayLabel && isPreview &&
            <div className={styles.questionTitle}>
              {questionData.data.label}
              { get(questionData, 'data.isRequired', true) &&
                <span
                    className={styles.requiredAsterisk}
                    data-testid={`question-${questionData.id}__required-mark`}
                > *</span>
              }
            </div>
        }
        {children}
      </div>
      {
          shouldDisplayRequiredToggle &&
            <div
                onClick={(event) => event.stopPropagation()}
                className={classnames(
                    styles.cardFooter,
                    { [styles.cardFooterActive]: !isPreview }
                )}
            >
                <Switch
                    className={styles.switch}
                    label={requiredLabel}
                    labelPlacement='start'
                    color='default'
                    checked={isRequired}
                    onChange={toggleIsRequired}
                    data-testid={`question-${questionData.id}__required-toggle`}
                />
            </div>
      }
    </div>
  );
};

CardBuilder.propTypes = {
  dragHandleProps: PropTypes.shape({
    onMouseDown: PropTypes.func.isRequired,
    onTouchStart: PropTypes.func.isRequired
  }).isRequired,
  commonProps: PropTypes.shape({
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        callback: PropTypes.func.isRequired
      }).isRequired
    ),
    isPreview: PropTypes.bool,
    requiredLabel: PropTypes.string.isRequired,
    onToggleIsRequired: PropTypes.func.isRequired,
    questionData: PropTypes.shape({
      data: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.any,
        isRequired: PropTypes.bool,
      }).isRequired,
      id: PropTypes.string.isRequired,
    }).isRequired,
    handleClick: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
  shouldDisplayLabel: PropTypes.bool,
  shouldDisplayRequiredToggle: PropTypes.bool,
  shouldDisplayeAssistiveText: PropTypes.bool
};

CardBuilder.defaultProps = {
  commonProps: {
    actions: [],
    isPreview: true,
  },
  children: null,
  shouldDisplayLabel: true,
  shouldDisplayRequiredToggle: true,
  shouldDisplayeAssistiveText: true
}

export default CardBuilder;
